import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';
import { keys } from 'lodash';

const sizes = {
  s: { containerSize: 4, titleSize: 4, contentSize: 8 },
  m: { containerSize: 8, titleSize: 2, contentSize: 10 },
  l: { containerSize: 12, titleSize: 4, contentSize: 8 },
};

const contentAligns = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

export const CardSection = ({ title, children, size, contentAlign }) => {
  const { containerSize, titleSize, contentSize } = sizes[size];
  const justifyContent = contentAligns[contentAlign];
  return (
    <Grid item xs={containerSize}>
      <Box mb={1}>
        <Grid container spacing={2}>
          {title && (
            <Grid item xs={titleSize}>
              <Typography variant="body2" style={{ fontWeight: 800 }}>
                {title}
              </Typography>
            </Grid>
          )}
          <Grid item xs={title ? contentSize : containerSize}>
            <Grid item container justifyContent={justifyContent}>
              {children}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

CardSection.defaultProps = {
  size: 's',
  contentAlign: 'left',
};

CardSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.oneOf(keys(sizes)),
  contentAlign: PropTypes.oneOf(keys(contentAligns)),
};
